export const WHO_IS_ONLINE_ENTITY = 'who-is-online';
